import colores from "../../../shared/constants/styles";
import IFilterComposicion from "./interface/IFilterComposicion";
import { connect } from "react-redux";
import { useEffect } from "react";
import { FormControl, TextField } from "@mui/material";

interface IFilterProps {
  filter: IFilterComposicion;
  onSelectedFilter: (filter: IFilterComposicion) => void;
  getFilterComposicion: () => void;
  isAdmin: boolean;
  clienteId: string;
}

const Filter = (props: IFilterProps) => {
  const handleDocumentoToChange = (event: any) => {
    props.onSelectedFilter({
      ...props.filter,
      documento: event.target.value,
    });
  };

  const search = (event: any) => {
    event.preventDefault();
    props.getFilterComposicion();
  };

  const handleClienteIdToChange = (event: any) => {
    props.onSelectedFilter({
      ...props.filter,
      clienteId: event.target.value,
    });
  };

  const handleClean = () => {
    props.onSelectedFilter({
      documento: "",
      clienteId: props.isAdmin ? "" : props.clienteId,
      page: 0,
      rowPerPage: 0,
      isAdmin: props.isAdmin,
      sortField: { field: "fechaEmision", order: "DESC" },
    });
  };

  useEffect(() => {}, []);

  return (
    <div className="container-fluid mx-0 px-0 w-100" style={{ margin: "2rem" }}>
      <div
        className="container-fluid"
        style={{
          backgroundColor: "white",
          width: "100%",
          overflow: "hidden",
          clear: "both",
          marginBottom: "1.85rem",
        }}
      >
        <form
          className="row row-cols-1 row-cols-sm-8 row-cols-md-8"
          onSubmit={search}
          style={{ margin: "1vw" }}
        >
          <div>
            <div className="row">
              <div className="col-2">
                <FormControl fullWidth>
                  <TextField
                    id="documento"
                    value={props.filter.documento}
                    name="documento"
                    onChange={handleDocumentoToChange}
                    label="Documento"
                    variant="outlined"
                  />
                </FormControl>
              </div>
              {props.isAdmin && (
                <div className="col-2">
                  <FormControl fullWidth>
                    <TextField
                      id="clienteId"
                      value={props.filter.clienteId}
                      name="clienteId"
                      onChange={handleClienteIdToChange}
                      label="Cliente"
                      variant="outlined"
                    />
                  </FormControl>
                </div>
              )}
            </div>
          </div>
          <div style={{ margin: "1vw" }}>
            <button
              type="submit"
              style={{ background: colores.rojo, color: "white" }}
              className="btn"
            >
              Buscar
            </button>
            <button
              style={{
                background: colores.white,
                color: "red",
                borderColor: "red",
                marginLeft: "2vh",
              }}
              className="btn"
              onClick={handleClean}
            >
              Limpar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default connect((state: any) => ({
  loading: state.cuentacorriente.loading,
}))(Filter);
